import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { EmployeeTeamRequest, EmployeeTeamResponse } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { EmployeeTeamDto } from "./dto/employee-team.dto";
import { EmployeeTeamAdapter } from "./employee-team.adapter";
import { EmployeeTeamEntity } from "./entity/employee-team.entity";

@Injectable()
export class EmployeeTeamService{
    constructor(
        @InjectRepository(EmployeeTeamEntity)
        private repo:Repository<EmployeeTeamEntity>,
        private adapter:EmployeeTeamAdapter
    ){}
    async getEmployeeTeamDetails(id:number):Promise<EmployeeTeamEntity>{
        const employeeTeamResponse = await this.repo.findOne({
            where:{id:id}
        });
        if(employeeTeamResponse){
            return employeeTeamResponse;
        }else{
            return null;
        }
    }

    
    async createEmployeeTeam(dto:EmployeeTeamDto , isUpdate:boolean):Promise<EmployeeTeamResponse>{
        try{
            if(isUpdate){
                const entity = await this.getEmployeeTeamDetails(dto.id);
                if(entity){
                    throw new ErrorResponse(11104,'Employee Team Already Exists');
                }
            }else{
                const entity = await this.getEmployeeTeamDetails(dto.id);
                if(entity){
                    if(entity.id != dto.id){
                        throw new ErrorResponse(11104,'Employee Team Already Exists')
                    }
                }
            }
            const convertedEntity: EmployeeTeamEntity = this.adapter.convertDtoToEntity(dto, isUpdate);
            const savedEntity: EmployeeTeamEntity = await this.repo.save(convertedEntity);
            const savedDto: EmployeeTeamDto = this.adapter.convertEntityToDto(savedEntity);
            if (savedDto) {
                const response = new EmployeeTeamResponse(true, 1, isUpdate ? 'Employee Team Updated Successfully' : 'Employee Team Created Successfully');
                return response;
            } else {
                throw new ErrorResponse(11106, 'Employee Team saved but issue while transforming it into DTO');
            }
        }catch (error) {
            throw error;
        }
    }

    async getAllEmployeeTeamActions(): Promise<EmployeeTeamResponse> {
        try {
            const empDto: EmployeeTeamDto[] = [];
            const empEntity: EmployeeTeamEntity[] = await this.repo.find({ order: { id: 'DESC' } });
            if (empEntity.length) {
                empEntity.forEach(Entity => {
                    const convertedDto: EmployeeTeamEntity = this.adapter.convertEntityToDto(Entity);
                    empDto.push(convertedDto);
                });
                const response = new EmployeeTeamResponse(true, 1, 'Employee Team Retrieved Successfully',empDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllActiveEmployeeTeamActions(): Promise<EmployeeTeamResponse> {
        try {
            const empDto: EmployeeTeamDto[] = [];
            const empEntity: EmployeeTeamEntity[] = await this.repo.find({ order: { id: 'ASC' }, where: { isActive: true }, });
            if (empEntity) {
                empEntity.forEach(Entity => {
                    const convertedEntity: EmployeeTeamDto = this.adapter.convertEntityToDto(Entity);
                    empDto.push(convertedEntity);
                });
                const response = new EmployeeTeamResponse(true, 11108, 'Active Employee Team Retrieved Successfully');
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    
    async getEmployeeTeamById(id: number): Promise<EmployeeTeamEntity> {
        const response = await this.repo.findOne({
            where: { id: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateEmployeeTeam(empReq: EmployeeTeamRequest): Promise<EmployeeTeamResponse> {
        try {
            const empExists = await this.getEmployeeTeamById(empReq.id);
            if (empExists) {
                if (empReq.versionFlag != empExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Employee Team information. Refresh and try again');
                } else {
                    const empStatus = await this.repo.update(
                        { id: empReq.id },
                        { isActive: empReq.isActive, updatedUser: empReq.updatedUser }
                    );
                    if (empExists.isActive) {
                        if (empStatus.affected) {
                            const empResponse: EmployeeTeamResponse = new EmployeeTeamResponse(true, 10115, 'Employee Team is de-activated successfully');
                            return empResponse;
                        } else {
                            throw new ErrorResponse(10111, ' Employee Team is already de-activated');
                        }
                    } else {
                        if (empStatus.affected) {
                            const empResponse: EmployeeTeamResponse = new EmployeeTeamResponse(true, 10114, 'Employee Team is activated successfully');
                            return empResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Employee Team is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

}